module.exports = __webpack_public_path__ + "static/media/80.7e897460.jpg";